import React, { useEffect, useContext, useState, forwardRef } from 'react';
import Api from '../../../api';
import Avatar from '../../Avatar';
import { AdminContext } from '../../../context/AdminContext';
import ToolbarIcons from '../../../icons/toolbar';
import Cookies from 'js-cookie';
import CheckToken from '../../../functions/CheckToken';
import Loader from '../../Loader';
import blanckUser from '../../../../../assets/imgs/blank-profile-picture.png';
import blankGroup from '../../../../../assets/imgs/blank-group-picture.png';

import AppIcons from '../../../icons';
import UserMoreBox from '../../UserMoreBox';
import AppInput from '../../AppInput';
import findMessageTypes from '../../../functions/FindMessageType';
import SearchPart from '../../../components/Searchpart';

const ChatSearch = forwardRef((props, ref) => {
  const {
    themeColor,
    userChannelId,
    setUserChannelId,
    direction,
    setUpdateSocket,
    privateUsers,
    setPrivateUsers,
    setSharedUser,
    sharedUser,
    setActiveAudio,
    setActiveMessage,
    openBox,
    setopenBox,
    setShowSearch,
    setShowAbsolute,
    activeUser,
    setOpenCreateGroup,
    showSearch,
  } = useContext(AdminContext);
  // const [openBox, setopenBox] = useState();

  // const clickItem = (item, user) => {
  //   if (item?.id == 1) {
  //     pinFuncton(user);
  //   }
  //   if (item?.id == 2) {
  //     deleteFunction(user);
  //   }
  //   if (item?.id == 3) {
  //     blockFunction(user);
  //   }
  // };

  // const pinFuncton = (x) => {
  //   console.log('xxxxxxxx', x);
  //   Api.pinUser(x?.users?.[0]?.id)
  //     .then((res) => {
  //       setUpdateSocket('user');
  //       setopenBox(false);
  //     })
  //     .catch((err) => {});
  // };
  // const deleteFunction = (x) => {
  //   console.log(
  //     'xx',
  //     x?.users?.[0]?.channelUser?.channelId ==
  //       sharedUser?.users?.[0]?.channelUser?.channelId
  //   );

  //   Api.deleteUser(x?.id)
  //     .then((res) => {
  //       // setUpdateSocket('user');
  //       setopenBox(false);
  //       if (
  //         x?.users?.[0]?.channelUser?.channelId ==
  //         sharedUser?.users?.[0]?.channelUser?.channelId
  //       ) {
  //         setSharedUser();
  //       }
  //       if (x?.users?.[0]?.channelUser?.channelId == userChannelId) {
  //         props?.setMessages([]);
  //         Api.privateChatUsersChat()
  //           .then((res) => {
  //             if (res?.data?.response?.length != 0) {
  //               setUserChannelId(
  //                 res?.data?.response?.[0]?.users?.[0]?.channelUser?.channelId
  //               );
  //             } else {
  //               setUserChannelId();
  //             }
  //             props?.setActiveUser(res?.data?.response?.[0]);
  //           })
  //           .catch((err) => {});
  //       } else {
  //         setUpdateSocket('user');
  //       }
  //     })
  //     .catch((err) => {});
  // };
  // const blockFunction = (x) => {
  //   // Api.blockUser(x?.users?.[0]?.channelUserId)
  //   //   .then((res) => {
  //   //     setUpdateSocket('user');
  //   //     setopenBox(false);
  //   //   })
  //   //   .catch((err) => {});
  //   ref?.current?.emit(
  //     'private:blockUser',
  //     { channelId: x?.users?.[0]?.channelUser?.channelId },
  //     (data) => {
  //       // setUpdateSocket('user');
  //       // setopenBox(false);
  //     }
  //   );
  //   // if (x?.block == 0) {
  //   //   ref.current.emit(
  //   //     'private:disconnect',
  //   //     { channelId: userChannelId },
  //   //     (message) => {}
  //   //   );
  //   // }
  // };
  console.log(
    'users',
    props?.users,
    privateUsers?.[0]?.users?.[0]?.id,
    sharedUser,
    privateUsers
  );
  function isJSON(str) {
    try {
      console.log('kkkkkkkkkkkkkk', !!str);
      return JSON.parse(str);
    } catch (e) {
      return false;
    }
  }
  // ${
  //   themeColor == 'white' ? ' whiteThemeBoxShadow' : ' grayThemeBoxShadow'
  // }
  return (
    <div
      className={`chat__sidebar relative ${
        props?.showUsers ? 'flex-02' : 'flex-02'
      } chatbar ${direction == 'rtl' ? 'right-0' : 'left-0'} headerBg`}
      id="sidebar"
    >
      <div
        className={
          themeColor == 'white' ? 'usersBorderWhite' : 'usersBorderGray'
        }
      >
        <div
          className={`flex flex-row justify-between items-center w-full`}
        ></div>

        <div className="usersColor">
          <SearchPart
            ref={props?.ref}
            setServerError={props?.setServerError}
            fileType={props?.fileType}
            loadingFile={props?.loadingFile}
            setLoadingFile={props?.setLoadingFile}
            loadingFileButton={props?.loadingFileButton}
            setLoadingFileButton={props?.setLoadingFileButton}
            setLoadingOldMessages={props?.setLoadingOldMessages}
            setTypingStatus={props?.setTypingStatus}
            users={props?.users}
            chatTypePrivate={props?.chatTypePrivate}
            replyValue={props?.replyValue}
            setReplyValue={props?.setReplyValue}
            setMessages={props?.setMessages}
            content={props?.content}
            handleSendMessage={props?.handleSendMessage}
            sendFunction={props?.sendFunction}
            notTyping={props?.notTyping}
            message={props?.message}
            setMessage={props?.setMessage}
            handleDrag={props?.handleDrag}
            handleDrop={props?.handleDrop}
            sendContact={props?.sendContact}
          />
        </div>
      </div>
      <div
        className={`createGroupButton cursor-pointer ${
          direction == 'rtl' ? 'createGroupButtonRtl' : 'createGroupButtonLtr'
        }`}
        onClick={() => {
          setOpenCreateGroup(true);
        }}
      >
        <AppIcons.GroupIcon width={'40px'} height={'40px'} fill="#fff" />
      </div>
    </div>
  );
});

export default ChatSearch;
